var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMonitor = function SvgMonitor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ef463b87-c47e-41ee-ba4f-2652067f5d58",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 472.3 518.73",
    width: 16,
    height: 16,
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bdf7b18f-2976-46a8-a244-f909850a0672",
    x1: -440.87,
    y1: 107.09,
    x2: -441.39,
    y2: 107.9,
    gradientTransform: "translate(208577.5 -55475.87) scale(472.3 518.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ff7139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ff5854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ff4f5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ff3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f92261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5156c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b5de39b5-793d-412e-aaa7-42baa9fa18c3",
    x1: -440.8,
    y1: 107.1,
    x2: -441.31,
    y2: 107.91,
    gradientTransform: "translate(183205.83 -55475.87) scale(414.9 518.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff44f",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff44f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a7cc960b-5898-4b62-8ae6-0459770f8e9a",
    x1: -440.75,
    y1: 108.19,
    x2: -440.75,
    y2: 106.96,
    gradientTransform: "translate(108382.31 -43667.05) scale(245.1 408.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a8ee6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#5c79f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#9059ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c139e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee293ebb-20c5-4f6f-9033-78f887ee5f8b",
    x1: -440.75,
    y1: 107.96,
    x2: -440.75,
    y2: 107.13,
    gradientTransform: "translate(108382.31 -43667.05) scale(245.1 408.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00458b",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#a050ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bfced3a5-29fe-48b6-a95e-88edb90aa722",
    x1: -441.32,
    y1: 107.05,
    x2: -440.42,
    y2: 107.59,
    gradientTransform: "translate(108382.31 -43667.05) scale(245.1 408.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e008b",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c846cb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad6fa078-9ed8-42ce-af3f-b411b60feb8b",
    x1: -439.19,
    y1: 106.82,
    x2: -438.68,
    y2: 107.35,
    gradientTransform: "translate(30645 -6692.09) scale(69.1 66.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#960e18",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#a91522",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d9283c",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff3750",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fx-monitor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ef3e6c8a-77d0-4ac3-8596-d810ac24de41",
    "data-name": "Artboard"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ee95fe3e-a9c9-4fdf-8412-e7821a84e339",
    "data-name": "Shape",
    d: "M476.2,370.7V169.3a63.13,63.13,0,0,0-31.4-54.2L393,85.2l51.8,29.9a62.92,62.92,0,0,1,31.4,54.2V370.7ZM467.8,401a61.38,61.38,0,0,1-22.9,22.9l-81.2,46.9c-.2.1-.5.2-.7.3a24.08,24.08,0,0,1-3.3,1.5c-.3.1-.7.3-1.1.4a23.25,23.25,0,0,1-4.4,1,4.1,4.1,0,0,1-1.1.1,19.42,19.42,0,0,1-2.4.2c-.4,0-.8-.1-1.2-.1s-.8-.1-1.2-.1a20.48,20.48,0,0,1-4.2-.7,2.35,2.35,0,0,1-.8-.2,20.94,20.94,0,0,1-3.5-1.3c-.3-.1-.6-.3-.9-.4a28.46,28.46,0,0,1-3.7-2.3c-.3-.2-.5-.4-.8-.6a24.43,24.43,0,0,1-2.9-2.7c-.2-.2-.4-.3-.5-.5a31.55,31.55,0,0,1-2.2-2.9L285.7,397a133.49,133.49,0,0,1-45.7,8c-74.7,0-135.4-60.8-135.4-135.5S165.4,134,240.1,134s135.5,60.8,135.5,135.5a135.16,135.16,0,0,1-45,100.7L359,413.3l56.2-32.5a19.35,19.35,0,0,0,3.6-2.8,17.57,17.57,0,0,1-3.7,2.9l-56.2,32.5,8.8,14.1a36.57,36.57,0,0,0,49.4,12.4l27.8-16A62.86,62.86,0,0,0,467.8,401ZM232.9,61.2a14,14,0,0,0-1.7.9l-136.8,79L65,158.1a17.93,17.93,0,0,0-8.9,15.5V365.4A17.93,17.93,0,0,0,65,380.9l166.1,95.9A26.05,26.05,0,0,1,218,525.4a25.66,25.66,0,0,1-13-3.5l-169.8-98A62.82,62.82,0,0,1,3.9,369.7V169.3a62.7,62.7,0,0,1,31.3-54.2l3.7-2.1L205.1,17.1l3.7-2.1a62.81,62.81,0,0,1,62.5,0l3.7,2.1,52.8,30.4q-3.45-2.1-6.9-3.9a54.92,54.92,0,0,0-53.7-.8ZM156.6,269.5A83.4,83.4,0,1,0,240,186.1,83.48,83.48,0,0,0,156.6,269.5Z",
    transform: "translate(-3.9 -6.68)",
    fill: "url(#bdf7b18f-2976-46a8-a244-f909850a0672)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M412.9,442.4l-49.2,28.4c-.2.1-.5.2-.7.3a24.08,24.08,0,0,1-3.3,1.5c-.3.1-.7.3-1.1.4a23.25,23.25,0,0,1-4.4,1,4.1,4.1,0,0,1-1.1.1,19.42,19.42,0,0,1-2.4.2c-.4,0-.8-.1-1.2-.1s-.8-.1-1.2-.1a20.48,20.48,0,0,1-4.2-.7,2.35,2.35,0,0,1-.8-.2,20.94,20.94,0,0,1-3.5-1.3c-.3-.1-.6-.3-.9-.4a28.46,28.46,0,0,1-3.7-2.3c-.3-.2-.5-.4-.8-.6a24.43,24.43,0,0,1-2.9-2.7c-.2-.2-.4-.3-.5-.5a31.55,31.55,0,0,1-2.2-2.9L285.7,397a133.49,133.49,0,0,1-45.7,8c-74.7,0-135.4-60.8-135.4-135.5S165.4,134,240.1,134s135.5,60.8,135.5,135.5a135.16,135.16,0,0,1-45,100.7L359,413.3l56.2-32.5a19.35,19.35,0,0,0,3.6-2.8,17.57,17.57,0,0,1-3.7,2.9l-56.2,32.5,8.8,14.1C377.1,442.7,396.6,448.6,412.9,442.4ZM232.9,61.2a14,14,0,0,0-1.7.9l-136.8,79L65,158.1a17.93,17.93,0,0,0-8.9,15.5V365.4A17.93,17.93,0,0,0,65,380.9l166.1,95.9A26.05,26.05,0,0,1,218,525.4a25.66,25.66,0,0,1-13-3.5l-169.8-98A62.82,62.82,0,0,1,3.9,369.7V169.3a62.7,62.7,0,0,1,31.3-54.2l3.7-2.1L205.1,17.1l3.7-2.1a62.81,62.81,0,0,1,62.5,0l3.7,2.1,40.3,23.3a57,57,0,0,0-48.1,2.4ZM156.6,269.5A83.4,83.4,0,1,0,240,186.1,83.48,83.48,0,0,0,156.6,269.5Z",
    transform: "translate(-3.9 -6.68)",
    fill: "url(#b5de39b5-793d-412e-aaa7-42baa9fa18c3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "e3d910b4-eb56-4c43-933a-9127f14fca15",
    "data-name": "Path",
    d: "M444.8,115.1,393,85.2s-42.9-24.8-72.1-41.6a54.92,54.92,0,0,0-53.7-.8L231.1,62.2a18,18,0,0,1,17.8,0l166.2,95.9a17.93,17.93,0,0,1,8.9,15.5V365.4a17.93,17.93,0,0,1-8.9,15.5l-56.2,32.5,8.8,14.1a36.57,36.57,0,0,0,49.4,12.4l27.8-16a62.7,62.7,0,0,0,31.3-54.2V169.3A62.92,62.92,0,0,0,444.8,115.1Z",
    transform: "translate(-3.9 -6.68)",
    fillRule: "evenodd",
    fill: "url(#a7cc960b-5898-4b62-8ae6-0459770f8e9a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M444.8,115.1,393,85.2s-42.9-24.8-72.1-41.6a54.92,54.92,0,0,0-53.7-.8L231.1,62.2a18,18,0,0,1,17.8,0l166.2,95.9a17.93,17.93,0,0,1,8.9,15.5V365.4a17.93,17.93,0,0,1-8.9,15.5l-56.2,32.5,8.8,14.1a36.57,36.57,0,0,0,49.4,12.4l27.8-16a62.7,62.7,0,0,0,31.3-54.2V169.3A62.92,62.92,0,0,0,444.8,115.1Z",
    transform: "translate(-3.9 -6.68)",
    fillRule: "evenodd",
    fill: "url(#ee293ebb-20c5-4f6f-9033-78f887ee5f8b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M444.8,115.1,393,85.2s-42.9-24.8-72.1-41.6a54.92,54.92,0,0,0-53.7-.8L231.1,62.2a18,18,0,0,1,17.8,0l166.2,95.9a17.93,17.93,0,0,1,8.9,15.5V365.4a17.93,17.93,0,0,1-8.9,15.5l-56.2,32.5,8.8,14.1a36.57,36.57,0,0,0,49.4,12.4l27.8-16a62.7,62.7,0,0,0,31.3-54.2V169.3A62.92,62.92,0,0,0,444.8,115.1Z",
    transform: "translate(-3.9 -6.68)",
    fillRule: "evenodd",
    fill: "url(#bfced3a5-29fe-48b6-a95e-88edb90aa722)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M323.4,269.5A83.4,83.4,0,1,0,240,352.9,83.48,83.48,0,0,0,323.4,269.5Z",
    transform: "translate(-3.9 -6.68)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.9,407.3l-24.4-37a136.28,136.28,0,0,1-44.7,26.8l25.9,39.4Q333.6,422.25,354.9,407.3Z",
    transform: "translate(-3.9 -6.68)",
    fillRule: "evenodd",
    opacity: 0.9,
    fill: "url(#ad6fa078-9ed8-42ce-af3f-b411b60feb8b)",
    style: {
      isolation: "isolate"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMonitor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/monitor.f8b7befaa9e16fbd494d5d856ffe50ad.svg";